var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-alert',{staticClass:"ml-0 mb-0 mr-0",attrs:{"text":"","icon":_vm.data.icon,"color":_vm.data.color}},[_c('div',{class:_vm.getCustomCssClass(_vm.data)},[_c('ParagraphBlock',{attrs:{"html":_vm.data.content}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }